/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

import axios from 'axios'
import { cacheAdapterEnhancer } from 'axios-extensions';
import localforage from 'localforage'

const globalCache = localforage.createInstance({
  name: 'cspglobal',
})

const baseObj = {
  baseURL: `${process.env.VUE_APP_SERVER_URL}/public/`,
  withCredentials: false,
  headers: {
    'x-clientid': process.env.VUE_APP_SERVER_API_KEY,
  },
  adapter: cacheAdapterEnhancer(axios.defaults.adapter),
}

export default {
  /**
   * Make an api call to the server. Token in local storage is required
   */
  Api() {
    return axios.create(baseObj)
  },
  /**
   * Check if server is available
   */
  ping() {
    this.Api().get('')
      .then(response => response.status === 200)
  },
  async States() {
    const cachedResponse = await globalCache.getItem('States')
    if (cachedResponse) return JSON.parse(cachedResponse)
    return this.Api().get('csp/state')
      .then(response => {
        globalCache.setItem('States', JSON.stringify(response.data)).then((value) => {
          // Do other things once the value has been saved.
          // console.log(value);
        }).catch((err) => {
          // This code runs if there were any errors
          console.log(err);
        });
        return response.data
      })
  },
  async Country() {
    const cachedResponse = await globalCache.getItem('Country')
    if (cachedResponse) return JSON.parse(cachedResponse)
    return this.Api().get('csp/country')
      .then(response => {
        globalCache.setItem('Country', JSON.stringify(response.data)).then((value) => {
          // Do other things once the value has been saved.
          // console.log(value);
        }).catch((err) => {
          // This code runs if there were any errors
          console.log(err);
        });
        return response.data
      })
  },
  matchFingerprint(data) {
    return this.Api()
      .post('fingerprint/match', data)
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  },

  verifyPin(data) {
    return this.Api()
      .post('fingerprint/verifyPin', data)
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  },

  updateEmployee(id, data) {
    return this.Api()
      .put(`fingerprint/${id}/employee`, data)
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  },

  getEmployeeById(id, data) {
    return this.Api()
      .get(`fingerprint/${id}/employee`, data)
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  },

  async PaymentProcessors() {
    const cachedResponse = await globalCache.getItem('PaymentProcessors')
    if (cachedResponse) return JSON.parse(cachedResponse)
    return this.Api().get('csp/paymentProcessors')
      .then(response => {
        globalCache.setItem('PaymentProcessors', JSON.stringify(response.data)).then((value) => {
          // Do other things once the value has been saved.
          // console.log(value);
        }).catch((err) => {
          // This code runs if there were any errors
          console.log(err);
        });
        return response.data
      })
  },
  async MasterCategories() {
    const cachedResponse = await globalCache.getItem('MasterCategories')
    if (cachedResponse) return JSON.parse(cachedResponse)
    return this.Api().get('csp/category')
      .then(response => {
        globalCache.setItem('MasterCategories', JSON.stringify(response.data)).then((value) => {
          // Do other things once the value has been saved.
          // console.log(value);
        }).catch((err) => {
          // This code runs if there were any errors
          console.log(err);
        });
        return response.data
      })
  },
  async CSPCarriers() {
    const cachedResponse = await globalCache.getItem('CSPCarriers')
    if (cachedResponse) return JSON.parse(cachedResponse)
    return this.Api().get('csp/carrier')
      .then(response => {
        globalCache.setItem('CSPCarriers', JSON.stringify(response.data)).then((value) => {
          // Do other things once the value has been saved.
          // console.log(value);
        }).catch((err) => {
          // This code runs if there were any errors
          console.log(err);
        });
        return response.data
      })
  },
  GetPlans(params) {
    return this.Api().get('billing/plans', { params })
      .then(response => response.data)
  },
  getPriceList(params) {
    return this.Api().post('stripe/getPriceList', params)
      .then((response) => {
        return response.data
      })
      .catch((error) => { throw error })
  }
}
